// Shared layout hooks for the Horizon admin shell.
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import axios from "axios";

/**
 * Fetches the connected admin right level (0 until loaded / on error).
 * @returns {number} the user's right level
 */
export function useUserRight() {
  const [right, setRight] = useState(0);
  useEffect(() => {
    let cancelled = false;
    axios.get("profiles/my_profile")
      .then(({ data }) => { if (!cancelled) setRight(data?.right ?? 0); })
      .catch(() => { if (!cancelled) setRight(0); });
    return () => { cancelled = true; };
  }, []);
  return right;
}

/**
 * Scrolls the window back to top whenever the route changes.
 * @returns {void}
 */
export function useScrollToTop() {
  const location = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [location.pathname]);
}
